export const blockIconsCommonactionsEventAvailableNew = (
	<span className='material-symbols-outlined'>event_available</span>
);
